import {HtmlDialog, QRCodeST, showNotice} from "./functions.js";
import JSX from "./react.js";
import QRCodeStyling from "./qr-code-styling.js";

function renderImage (ctx: CanvasRenderingContext2D, blob: Blob, dx: number, dy: number, width: number, height: number): any{
    const img = new Image();

    img.onload = function(){
        ctx.drawImage(img, dx, dy, width, height)
    }

    img.src = URL.createObjectURL(blob);
}
function shadowRect(ctx: CanvasRenderingContext2D, x: number, y: number,w: number,h: number, repeats: number, color: string){
    // set stroke & shadow to the same color
    ctx.strokeStyle=color;
    ctx.shadowColor=color;
    // set initial blur of 3px
    ctx.shadowBlur=3;
    // repeatedly overdraw the blur to make it prominent
    for(let i=0;i<repeats;i++){
        // increase the size of blur
        ctx.shadowBlur+=0.25;
        // stroke the rect (which also draws its shadow)
        ctx.strokeRect(x,y,w,h);
    }
    // cancel shadowing by making the shadowColor transparent
    ctx.shadowColor='rgba(0,0,0,0)';
    // restroke the interior of the rect for a more solid colored center
    ctx.lineWidth=2;
    ctx.strokeRect(x+2,y+2,w-4,h-4);
}
const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim()!
class DialogShare{
    private readonly dialog: JQuery
    private readonly size: number;
    private readonly loc: string =($('#short_link').attr('content')! as string);
    private readonly qrCode: QRCodeST;
    private readonly posters: JQuery<HTMLCanvasElement>;
    private readonly qrCodeElement: JSX.RefObject = {};
    constructor() {
        this.dialog = $(<HtmlDialog>
        <div className="top-data">
            <div className="fa fa-times-circle top-icon-close-dialog cancel-button" style="margin: 5px" />
            <h1>Поделиться</h1>
        </div>    
        <div className="content scroll-flex-container" style="margin-bottom: 10px; display: flex; justify-content: space-around; align-items: center;">
            <div className="poster-a" style="flex-grow: 0; text-align: center">
                <h3>Постер:</h3>
                <canvas className="poster-canvas"></canvas>
            </div>
            <div style="text-align: center; flex-grow: 0">
                <h3>QR code</h3>
                <div className="content-qr" onClick={this.copyLink}>
                    <div id="qrcode" alt="Загрузка..." ref={this.qrCodeElement}></div>
                    <input type="text" value={this.loc} id="qr-link" readonly/>
                </div>

            </div>
        </div>
        </HtmlDialog>
    ).appendTo('body')
        this.size = Math.min(250, this.dialog.width()!-20,  this.dialog.height()!-20)
        this.qrCode = this.generateQrCode(this.qrCodeElement.value!)
        this.qrCode.getRawData().then(this.animateQRCode.bind(this));
        this.posters = this.dialog.find('.poster-canvas') as JQuery<HTMLCanvasElement>;
        this.initPosters();
    }
    private copyLink = async ()=>{
        try{
            await navigator.clipboard.writeText(this.loc);
            showNotice('Ссылка успешно скопирована', '!-_-!','success');
        }
        catch (e){
            showNotice('Не могу скопировать ссылку','-_-','error');
        }
    }
    private async animateQRCode(){
        const paths = $('#clip-path-dot-color').children();
        await (async function moveRandomPath(): Promise<void> {
            setTimeout(moveRandomPath, Math.random() / 3 * 1000+250);
            async function move(attrName: 'x'|'y', plus=Math.random()<.5): Promise<void>{
                const startPos:number = +(path.attr(attrName)||0);
                for(let i=1;i<=10;i++){
                    if(plus) path.attr(attrName, startPos+i)
                    else path.attr(attrName, startPos-i);
                    await new Promise(r=>setTimeout(r, 50));
                }
                for(let i=9;i>=0;i--){
                    if(plus) path.attr(attrName, startPos+i)
                    else path.attr(attrName, startPos-i);
                    await new Promise(r=>setTimeout(r, 50));
                }
                path.attr(attrName, startPos);
            }
            let path: JQuery;
            do path = paths.eq(Math.floor(Math.random() * paths.length))
            while (path.data('moving'));
            path.data('moving', true);
            await move(Math.random()<.5?'x':'y');
            path.data('moving', false);
        })();
    }
    private generateQrCode(appendTo?: HTMLElement): QRCodeST{
        const size= this.size;
        const qrCode = new QRCodeStyling({
            width: size,
            height: size,
            type: "svg",
            data: "HTTPS://"+this.loc.toUpperCase(),
            //fallback for firefox - it recognize svg wrong
            image: navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? "/img/icon/yummy-600.png" : '/img/icon/yummy-fav.svg',
            dotsOptions: {
                color: getColor('--main-red'),
                type: "classy",
                gradient:{
                    type:"linear",
                    rotation:0,
                    "colorStops":[
                        {
                            "offset":0,
                            "color":getColor('--main-red')
                        }, {
                            "offset":1,
                            "color": getColor('--main-red-hover')
                        }
                    ]
                }
            },
            backgroundOptions: {
                color: '#fff'
                //color: getComputedStyle(document.body).getPropertyValue('--background-first').trim(),
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 3,
                imageSize: 0.3
            },
            cornersSquareOptions:{
                color: "#333333",
            },
            cornersDotOptions:{
                color: '#333333'
            },
            qrOptions: {"typeNumber":"0","mode":"Byte","errorCorrectionLevel":"Q"}
        });
        if(appendTo) qrCode.append(appendTo);
        return qrCode;
    }
    private initPosters(){
        this.initPosterA(this.posters[0]);
    }
    private async initPosterA(canvas: HTMLCanvasElement){
        const posterGreat = await this.getBestCanvas();
        canvas.width = posterGreat.width;
        canvas.height = posterGreat.height;
        const context = canvas.getContext('2d')!;
        context.drawImage(posterGreat, 0, 0);
        // const el = $(document.createElement('div'));
        const qr = this.generateQrCode();
        if(qr._svgDrawingPromise) await qr._svgDrawingPromise;
        if(qr._canvasDrawingPromise) await qr._canvasDrawingPromise;
        const imageData = await qr.getRawData('png');
        renderImage(context, imageData!,canvas.width/2 - 100, canvas.height - 250, 200, 200);
        shadowRect(context, canvas.width/2 - 110, canvas.height - 260, 220, 220, 110, '#ffffff');
        context.font = "48px serif";
        context.textAlign = 'center'
        context.shadowBlur = 4;
        context.shadowOffsetX = 3;
        context.shadowOffsetY = 3;
        context.shadowColor=getColor('--main-red');
        context.fillText(this.loc, canvas.width /2, canvas.height-7);
        context.fillText(this.loc, canvas.width /2, canvas.height-7);

    }
    private async getBestCanvas():Promise<HTMLCanvasElement>{
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        let posterImg: JQuery<HTMLImageElement>|null = null;
        await new Promise<void>((r, f)=>{
            posterImg = $(<img src={this.posterImg.attr('src')}/>);
            posterImg.on('load' , r as any);
            posterImg.on('error', f);
        });
        try {
            canvas.width = posterImg![0].width;
            canvas.height = posterImg![0].height;
            canvas.getContext('2d')!.drawImage(posterImg![0]!, 0, 0);
        }catch (e){
            canvas.width = posterImg![0].width;
            canvas.height = posterImg![0].height;
            canvas.getContext('2d')!.drawImage(posterImg![0]!, 0, 0);
        }
        return canvas;
    }
    private get posterImg(): JQuery<HTMLImageElement>{
        return $('.poster-block img') as JQuery<HTMLImageElement>;
    }
}
//Share button click
export {DialogShare}